<template>
	<a v-if="getPicture" :href="getPicture.link" target="_blank" v-bind:class="{ second: second }">
		<img v-if="!pictureError" :src="getPicture.image" :alt="profile['source']['username']" @error="pictureError = true" />
		<span class="dynvibeEtiquette">
			<i class="icon-at"></i>
			<span>{{ profile["source"]["username"] }}</span>
		</span>
		<p v-if="pictureError" v-bind:style="{ backgroundColor: getPicture.color }">
			{{ profile["source"]["username"] ? profile["source"]["username"].substring(0, 1) : "_" }}
		</p>
	</a>
</template>

<script>
export default {
	name: "profilecircle",
	props: {
		profile: {},
		second: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			pictureError: false,
		};
	},
	computed: {
		getPicture() {
			let profilePicture = typeof this.profile["source"]["profile_pic"] !== "undefined" ? this.profile["source"]["profile_pic"] : "";
			profilePicture =
				profilePicture !== null
					? profilePicture
							.replace("http://twitter.com/", "https://avatars.io/twitter/")
							.replace("/profile_image?size=bigger", "/medium")
					: "";

			let color;
			switch (this.profile["profile_gender"]) {
				case "male":
					color = "#23056B";
					break;
				case "female":
					color = "#EF402E";
					break;
				default:
					color = "#33D1CD";
					break;
			}
			let link = this.profile["source"]
				? "http://" + this.profile["source"]["media"] + ".com/" + this.profile["source"]["username"]
				: "";

			return {
				image: profilePicture,
				link: link,
				color: color,
			};
		},
	},
};
</script>

<style scoped>
img {
	width: 82px;
	height: 82px;
}

.second img,
.second p {
	margin-top: 25px;
}

p {
	margin-bottom: 0;
}

i.icon-at {
	color: #ef402e;
}

.dynvibeEtiquette span {
	white-space: nowrap;
}
</style>
